import styled from "@emotion/styled";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
} from "antd";
import Button from "atoms/Button";
import { CALL_API } from "common/API";
import { displayErrorModal } from "common/common";
import { NON_EMPTY_REGEX, STATUS_CODE } from "common/Constants";
import { concat, find, get, includes, intersection, result } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { setLeaveList } from "redux/actions";
import {
  getAllDepartmentList,
  getClientid,
  getLeaveCategoryList,
  getLeaveList,
  getRoleList,
  getSelectedDepartmentId,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import {
  addDaysinDate,
  getKenyanDateTime,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import { bindActionCreators } from "redux";

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker,
  .ant-input-number {
    width: 100%;
  }
`;

const StyledButton = styled(Button)`
  width: 120px;
  border-radius: 5px;
  width: initial;
`;

const StyledFooterDiv = styled.div`
  padding-top: 30px;
`;

function LeaveForm({
  isModalVisible,
  closeModal,
  leaveCategoryList,
  leaveDetails,
  ClientId,
  AllDepartmentList,
  userRoleId,
  roleList,
  userInfo,
  userList,
  setLeaveListData,
  selectedDepartmentId,
  editLeaveDisable,
}) {
  console.log("editing leave--->");
  const [showLoader, toggleLoader] = useState(false);
  const [showLeaveValidationLoader, toggleLeaveValidationLoader] =
    useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [isCancelRequest, setCancelRequest] = useState(false);
  const [form] = Form.useForm();
  const [halfDay, setHalfDay] = useState(false);
  const [showHalfDayCheckbox, setShowHalfDayCheckbox] = useState(true);
  const { TextArea } = Input;
  const containerRef = useRef(null);

  const [weekendShiftUser, setWeekendShiftUser] = useState();
  const FindShiftUser = userList?.find(
    (item) => item.userid === userInfo?.userid
  );

  useEffect(() => {
    setWeekendShiftUser(FindShiftUser?.weekendShift);
  }, [FindShiftUser]);

  const FindName = (userid) => {
    const finduser = userList?.find((val) => val?.userid === userid);
    return finduser?.fullname;
  };

  const filterRoleList = roleList?.filter(
    (item) => item?.roleId === userRoleId
  );
  const filterDepartmentId = filterRoleList[0]?.department;
  const filterDepartment = AllDepartmentList?.filter((item) =>
    filterDepartmentId?.includes(item?.department_id)
  );

  const resetForm = () => {
    setShowHalfDayCheckbox(true);
    form.setFieldsValue({
      leave_id: "",
      start_date: momentDate(new Date()),
      end_date: momentDate(new Date()),
      number_of_days: 1,
      leave_type: "",
      description: "",
    });
  };

  useEffect(() => {
    resetForm();
  }, [userRoleId, leaveCategoryList]);

  const resetHalfDay = () => {
    setHalfDay(false);
    form.setFieldsValue({ number_of_days: 1 });
  };

  const updateHalfDay = (halfday) => {
    const { number_of_days } = form.getFieldsValue();
    const roundedDays = number_of_days;
    if (halfday === true) {
      if (number_of_days >= 0.5) {
        form.setFieldsValue({
          number_of_days: roundedDays - 0.5,
        });
      }
    } else {
      if (number_of_days >= 0.5) {
        form.setFieldsValue({
          number_of_days: Math.ceil(roundedDays),
        });
      }
    }
  };

  const [isSaturday, setIsSaturday] = useState("");
  const [isSunday, setIsSunday] = useState("");
  // useEffect(() => {
  //   if (isModalVisible) {
  //     if (
  //       moment(leaveDetails?.end_date).format("dddd") === "Saturday" &&
  //       moment(leaveDetails?.start_date).format("dddd") === "Saturday" &&
  //       moment(leaveDetails?.start_date).format("L") ===
  //       moment(leaveDetails?.end_date).format("L")
  //     ) {
  //       setShowHalfDayCheckbox(false);
  //     } else {
  //       setShowHalfDayCheckbox(true);
  //     }
  //   }
  // }, [isModalVisible]);

  // New Code
  const [weekendDisable, setWeekendDisable] = useState(true);
  // useEffect(() => {
  //   if (isModalVisible) {
  //     const startDate = form.getFieldValue("start_date");
  //     const endDate = form.getFieldValue("end_date");

  //     const dayStart = moment(startDate)?.format("dddd"); // ex: Saturday
  //     const dayEnd = moment(endDate)?.format("dddd");     // ex: Sunday

  //     const isSaturdayLeave = dayStart === "Saturday" || dayEnd === "Saturday";
  //     const isSundayLeave = dayStart === "Sunday" || dayEnd === "Sunday";
  //     setIsSaturday(isSaturdayLeave);
  //     setIsSunday(isSundayLeave);

  //     const satEnabled = weekendShiftUser?.saturdayEnabled;
  //     const sunEnabled = weekendShiftUser?.sundayEnabled;
  //     const satType = weekendShiftUser?.saturdayType;
  //     const sunType = weekendShiftUser?.sundayType;
  //     const notApplicable = weekendShiftUser?.notApplicable === false;

  //     let halfDay = false;
  //     const { number_of_days } = form.getFieldsValue();
  //     const roundedDays = number_of_days;
  //     if (isSaturdayLeave && notApplicable) {
  //       if (satEnabled && satType === "halfday") {
  //         halfDay = true;

  //         // if (number_of_days >= 0.5) {
  //         //   form.setFieldsValue({
  //         //     number_of_days: roundedDays - 0.5,
  //         //   });
  //         // }
  //       } else if (!satEnabled || satType === "fullday") {
  //         halfDay = false;
  //         // if (number_of_days >= 0.5) {
  //         //   form.setFieldsValue({
  //         //     number_of_days: Math.ceil(roundedDays),
  //         //   });
  //         // }
  //       }
  //     }

  //     if (isSundayLeave && notApplicable) {
  //       if (sunEnabled && sunType === "halfday") {
  //         halfDay = true;
  //         // if (number_of_days >= 0.5) {
  //         //   form.setFieldsValue({
  //         //     number_of_days: roundedDays - 0.5,
  //         //   });
  //         // }
  //       } else if (!sunEnabled || sunType === "fullday") {
  //         halfDay = false;
  //         // if (number_of_days >= 0.5) {
  //         //   form.setFieldsValue({
  //         //     number_of_days: Math.ceil(roundedDays),
  //         //   });
  //         // }
  //       }
  //     }
  //     // setWeekendDisable(halfDay);
  //     setHalfDay(halfDay);
  //     if(isSundayLeave && !sunEnabled){
  //       setShowHalfDayCheckbox(false);
  //     } else if(isSaturdayLeave && !satEnabled){
  //       setShowHalfDayCheckbox(false);
  //     } else{
  //       setShowHalfDayCheckbox(true);
  //     }

  //   }
  // }, [isModalVisible, form, showLeaveValidationLoader]);

  useEffect(() => {
    if (isModalVisible) {
      const startDate = form.getFieldValue("start_date");
      const endDate = form.getFieldValue("end_date");

      if (!startDate || !endDate) return;

      const endDay = moment(endDate).format("dddd");

      const isSaturday = endDay === "Saturday";
      const isSunday = endDay === "Sunday";

      setIsSaturday(isSaturday);
      setIsSunday(isSunday);

      const satEnabled = weekendShiftUser?.saturdayEnabled;
      const sunEnabled = weekendShiftUser?.sundayEnabled;
      const satType = weekendShiftUser?.saturdayType;
      const sunType = weekendShiftUser?.sundayType;
      const notApplicable = weekendShiftUser?.notApplicable === false;

      let halfDay = false;

      // ✅ Only check endDate for halfDay logic
      if (notApplicable) {
        if (isSaturday && satEnabled && satType === "halfday") {
          halfDay = true;
        } else if (isSunday && sunEnabled && sunType === "halfday") {
          halfDay = true;
        }
      }

      setHalfDay(halfDay);

      // ✅ Control halfDay checkbox visibility
      if ((isSaturday && !satEnabled) || (isSunday && !sunEnabled)) {
        setShowHalfDayCheckbox(false);
      } else {
        setShowHalfDayCheckbox(true);
      }
    }
  }, [isModalVisible, form, showLeaveValidationLoader]);

  useEffect(() => {
    if (!isModalVisible) {
      resetForm();
    }
  }, [isModalVisible]);
  console.log("leaveDetails--->", leaveDetails);
  useEffect(() => {
    const {
      user_leave_id = "",
      start_date = "",
      end_date = "",
      reason = "",
      number_of_days = 0,
      leave_category_id,
      isViewOnly,
      isCancel = false,
      department_id = "",
    } = leaveDetails;
    if (user_leave_id !== "") {
      setIsViewOnly(isViewOnly);
      setCancelRequest(isCancel);

      form.setFieldsValue({
        leave_id: user_leave_id,
        start_date: momentDate(start_date),
        end_date: momentDate(end_date),
        number_of_days: number_of_days,
        leave_type: leave_category_id,
        description: reason,
        remark: "",
        department: department_id,
      });
      if (
        !isNaN(parseFloat(number_of_days)) &&
        number_of_days.toString().includes(".")
      ) {
        setHalfDay(true);
      } else {
        setHalfDay(false);
      }
    } else if (start_date && end_date) {
      setCancelRequest(isCancel);
      form.setFieldsValue({
        start_date: momentDate(start_date),
        end_date: momentDate(end_date),
        leave_id: "",
        number_of_days: 1,
        leave_type: "",
        description: "",
        remark: "",
        department: "",
      });
      setHalfDay(false);
    }
  }, [leaveDetails, isModalVisible]);

  function getDates() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    const startDate = new Date(currentYear - 2, 0, 1);
    const endDate = new Date(currentYear + 1, 11, 31);

    return {
      startDate,
      endDate,
    };
  }

  const dates = getDates();

  const getLeaveList = async () => {
    return new Promise(async (resolve, reject) => {
      if (selectedDepartmentId) {
        const { code, leaves = [] } = await CALL_API(
          `leave-list/${ClientId}`,
          "post",
          {
            status_id: "4",
            start_date: dates.startDate,
            end_date: dates.endDate,
          }
        );

        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setLeaveListData(leaves.reverse());

          resolve(leaves);
        } else {
          reject([]);
        }
      } else {
        reject();
      }
    });
  };

  console.log("halfDay121-->", halfDay);
  // Note: First params is needed
  const onFinish = async (values, saveLeave = true) => {
    const startDate = form.getFieldValue("start_date");
    const endDate = form.getFieldValue("end_date");
    const dayStart = moment(startDate).format("dddd");
    const dayEnd = moment(endDate).format("dddd");

    const isSaturdayLeave = dayStart === "Saturday" || dayEnd === "Saturday";
    const isSundayLeave = dayStart === "Sunday" || dayEnd === "Sunday";

    const notApplicable = weekendShiftUser?.notApplicable === false;
    const satEnabled = weekendShiftUser?.saturdayEnabled;
    const sunEnabled = weekendShiftUser?.sundayEnabled;
    const satType = weekendShiftUser?.saturdayType;
    const sunType = weekendShiftUser?.sundayType;

    let halfDayFinal = false;
    if (
      isSaturdayLeave &&
      notApplicable &&
      satEnabled &&
      satType === "halfday"
    ) {
      halfDayFinal = true;
    }
    if (isSundayLeave && notApplicable && sunEnabled && sunType === "halfday") {
      halfDayFinal = true;
    }
    console.log("halfDayFinal121-->", halfDayFinal);
    if (saveLeave) toggleLoader(true);
    else toggleLeaveValidationLoader(true);
    const {
      start_date,
      end_date,
      number_of_days,
      leave_type,
      description,
      remark,
    } = form.getFieldsValue();
    const filterleavetype = leaveCategoryList?.filter(
      (item) => item.leave_category_id === leave_type?.toString()
    );
    console.log("filterleavetype[0]--->", filterleavetype[0]);
    const deptName = result(
      find(AllDepartmentList, (e) => {
        return finduser?.basedepartmentid?.includes(e.department_id);
      }),
      "department_name"
    );
    const { user_leave_id = "" } = leaveDetails;
    if (leave_type !== "") {
      const obj = {
        leave_id: user_leave_id,
        start_date: getMySqlDate(start_date),
        end_date: getMySqlDate(end_date),
        number_of_days,
        leave_category_id: leave_type.toString(),
        reason: description,
        decline_reason: isCancelRequest ? remark : "",
        is_cancel_request: isCancelRequest,
        isSaving: saveLeave,
        reporting_manager: finduser?.reportingmanager,
        reporting_manager_name: FindName(finduser?.reportingmanager),
        old_number_of_day: leaveDetails?.number_of_days
          ? leaveDetails?.number_of_days
          : "",
        holiday: filterleavetype[0]?.holiday?.length
          ? filterleavetype[0]?.holiday
          : "No",
        weekend: filterleavetype[0]?.weekend?.length
          ? filterleavetype[0]?.weekend
          : "No",
        isSaturday: filterleavetype[0]?.isSaturday?.length
          ? filterleavetype[0]?.isSaturday
          : "No",
        employeeid: filteruser[0]?.employeeid,
        leave_category_name: get(
          find(filteredCategoriesbygender, {
            leave_category_id: leave_type.toString(),
          }),
          "leave_category_name",
          ""
        ),
        fullname: filteruser[0]?.fullname,
        halfday: halfDayFinal ? "Yes" : halfDay ? "Yes" : "No",
        department_name: deptName,
        department_id: finduser?.basedepartmentid,
        baselocationid: finduser?.baselocationid,
      };
      const { code, leaveBalance, totalNumberOfDaysInLeave, reason } =
        await CALL_API(`save-leave/${ClientId}`, "post", obj);
      const payloadVariable = {
        leave_id: user_leave_id,
        start_date: getMySqlDate(start_date),
        end_date: getMySqlDate(end_date),
        number_of_days,
        leave_category_id: leave_type,
        reason: description,
        decline_reason: isCancelRequest ? remark : "",
        is_cancel_request: isCancelRequest,
        isSaving: saveLeave,
      };
      if (saveLeave) toggleLoader(false);
      else toggleLeaveValidationLoader(false);
      if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
        message.error(`Oops!! something went wrong`);
      } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
        if (
          filterleavetype[0]?.holiday === "No" ||
          filterleavetype[0]?.weekend === "No"
        ) {
          // if ((weekendShiftUser?.notApplicablefilter === false && weekendShiftUser?.saturdayEnabled) || (leavetype[0]?.holiday === "No" || filterleavetype[0]?.weekend === "No")) {
          message.error(`You cannot apply for leave on Holidays and Sundays`);
        } else if (filterleavetype[0]?.holiday === "No") {
          message.error(`You cannot apply for leave on Holidays`);
        } else if (filterleavetype[0]?.weekend === "No") {
          message.error(`You cannot apply for leave on Sundays`);
        } else {
          message.error(`Invalid payload. Please enter correct data`);
        }
      } else if (code === STATUS_CODE.RECORD_EXIST) {
        message.error(`Leave already exists`);
      } else if (code === STATUS_CODE.ANNUAL_LEAVE_AVAILABLE) {
        message.error(
          `You can not apply compassionate leave. You still have annual leaves.`
        );
      } else if (code === STATUS_CODE.SICK_LEAVE_AVAILABLE) {
        message.error(
          `You can not apply sick leave(half-pay). You still have sick leaves.`
        );
      } else if (code === STATUS_CODE.LEAVE_EXCEED) {
        form.setFieldsValue({
          number_of_days: totalNumberOfDaysInLeave,
        });
        displayErrorModal(
          `You are exceeding your leave quota. your current leave balance is ${leaveBalance}`
        );
      } else if (code === STATUS_CODE.SUCCESS) {
        if (saveLeave) {
          message.success(
            isCancelRequest
              ? "Leave application request has been submitted"
              : `Leave has been ${user_leave_id ? "updated" : "applied"}`
          );
          form.resetFields();
          closeModal(true);
          setShowHalfDayCheckbox(true);
          getLeaveList();
        } else {
          form.setFieldsValue({
            number_of_days: totalNumberOfDaysInLeave,
          });
        }
      }
    } else {
      message.error("kindly select the leave type");
      toggleLeaveValidationLoader(false);
    }
  };

  const restrictPastDate = (current, element) => {
    let customDate = moment("2022-08-01").format("YYYY-MM-DD");
    if (element === "end_date") {
      return current < moment(form.getFieldValue("start_date"));
    }
    return current && current < moment(customDate, "YYYY-MM-DD");
  };

  const validateDateRange = () => {
    const startDateValue = form.getFieldValue("start_date");
    const endDateValue = form.getFieldValue("end_date");

    if (startDateValue && endDateValue) {
      const startDate = moment(startDateValue);
      const endDate = moment(endDateValue);

      if (endDate.isBefore(startDate, "day")) {
        form.setFieldsValue({ end_date: startDate });
      }
      onFinish({}, false);
    }
  };

  const dateChange = () => {
    const startDate = form.getFieldValue("start_date");
    const endDate = form.getFieldValue("end_date");

    if (startDate && endDate) {
      onFinish({}, false);
      updateHalfDay();
    }
  };

  const hideHalfDay = () => {
    const { start_date, end_date } = form.getFieldsValue();
    if (
      moment(end_date).format("dddd") == "Saturday" &&
      moment(start_date).format("dddd") == "Saturday" &&
      moment(start_date).format("L") == moment(end_date).format("L")
    ) {
      setShowHalfDayCheckbox(false);
    } else {
      setShowHalfDayCheckbox(true);
    }
  };

  const updateEndDate = () => {
    const { start_date, number_of_days } = form.getFieldsValue();
    if (number_of_days >= 1) {
      const roundedDays = Math.ceil(number_of_days);
      form.setFieldsValue({
        number_of_days: roundedDays,
        end_date: momentDate(addDaysinDate(start_date, roundedDays - 1)),
      });
    }
  };

  const checkBoxStyle = {
    marginTop: "55px",
    position: "relative",
    bottom: "15px",
  };

  const finduser = userList?.find((item) => item?.userid === userInfo?.userid);

  const filterrolelist = roleList?.filter((val) => val?.roleId === userRoleId);
  const filterdepartmentid = filterrolelist[0]?.department;
  const filterlocationid = filterrolelist[0]?.locationId;

  const filterleaves = [];
  leaveCategoryList?.forEach((item) => {
    if (item?.locationId?.length > 0) {
      if (intersection(item?.locationId, filterlocationid).length > 0) {
        filterleaves.push(item);
      }
    }
  });

  const filteruser = userList?.filter(
    (item) => item.userid === userInfo?.userid
  );
  const filtergender = filteruser[0]?.gender;
  const filteredCategoriesbygender =
    filtergender?.toLowerCase() === "male"
      ? filterleaves?.filter(
          (item) => item.eligible?.toLowerCase() !== "female"
        )
      : filterleaves?.filter((item) => item.eligible?.toLowerCase() !== "male");
  return (
    <StyledModal
      title="Leave Details"
      visible={isModalVisible}
      onCancel={() => {
        closeModal(false);
        resetHalfDay();
        resetForm();
      }}
      width={600}
      footer={[]}
    >
      <Form
        form={form}
        name="leaveform"
        layout="vertical"
        initialValues={{
          leave_id: "",
          start_date: momentDate(getKenyanDateTime()),
          end_date: momentDate(getKenyanDateTime()),
          number_of_days: 1,
          description: "",
          remark: "",
        }}
        onFinish={onFinish}
      >
        <Row gutter={20}>
          <Col xs={24} sm={24} md={24} ref={containerRef}>
            <Form.Item
              label="Leave Type"
              name="leave_type"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Leave type is required",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search leave type"
                name="leave_type"
                optionFilterProp="leave_category_name"
                filterOption={(input, option) =>
                  option.leave_category_name
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) => {
                  optionA.leave_category_name
                    .toLowerCase()
                    .localeCompare(optionB.leave_category_name.toLowerCase());
                }}
                options={filteredCategoriesbygender}
                fieldNames={{
                  label: "leave_category_name",
                  value: "leave_category_id",
                }}
                // disabled={
                //    (
                //     isSaturday &&
                //     weekendShiftUser?.notApplicable === false &&
                //     weekendShiftUser?.saturdayEnabled
                //   ) ||
                //   (
                //     isSunday &&
                //     weekendShiftUser?.notApplicable === false &&
                //     weekendShiftUser?.sundayEnabled
                //   )
                //     ? false
                //     : false ||
                //   (leaveDetails?.status_id === "5" && leaveDetails?.having_cancel_request === "0") ||
                //   halfDay ? true : isViewOnly
                // }
                disabled={
                  (leaveDetails?.status_id === "5" &&
                    leaveDetails?.having_cancel_request === "0") ||
                  (halfDay &&
                    !(
                      (isSaturday &&
                        weekendShiftUser?.saturdayEnabled &&
                        weekendShiftUser?.notApplicable === false) ||
                      (isSunday &&
                        weekendShiftUser?.sundayEnabled &&
                        weekendShiftUser?.notApplicable === false)
                    ))
                    ? true
                    : isViewOnly
                }
                onChange={() => validateDateRange()}
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Start Date"
              name="start_date"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Start date is required",
                },
                () => ({
                  // Note: First param is needed
                  validator(rule, value) {
                    const date = moment(value);
                    return date.isValid()
                      ? Promise.resolve()
                      : Promise.reject();
                  },
                }),
              ]}
            >
              <DatePicker
                format="DD-MM-YYYY"
                onChange={() => {
                  validateDateRange();
                  hideHalfDay();
                }}
                // disabledDate={(current) => current && current < moment().startOf('day')}
                // disabled={isViewOnly || halfDay}
                disabled={
                  // moment(isSaturday?._d).format("dddd") === "Saturday" &&
                  (isSaturday &&
                    weekendShiftUser?.notApplicable === false &&
                    weekendShiftUser?.saturdayEnabled &&
                    weekendShiftUser?.saturdayType === "halfday") ||
                  // moment(isSunday?._d).format("dddd") === "Sunday" &&
                  (isSunday &&
                    weekendShiftUser?.notApplicable === false &&
                    weekendShiftUser?.sundayEnabled &&
                    weekendShiftUser?.sundayType === "halfday")
                    ? false
                    : halfDay
                }
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.start_date !== currentValues.start_date
              }
            >
              {() => (
                <Form.Item
                  label="End Date"
                  name="end_date"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: "End date is required",
                    },
                    () => ({
                      // first parameter is needed
                      validator(rule, value) {
                        const date = moment(value);
                        return date.isValid()
                          ? Promise.resolve()
                          : Promise.reject();
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    disabledDate={(current) =>
                      restrictPastDate(current, "end_date")
                    }
                    format="DD-MM-YYYY"
                    onChange={() => {
                      dateChange();
                      setHalfDay(false);
                      hideHalfDay();
                    }}
                    // disabled={isViewOnly || halfDay}
                    disabled={
                      // moment(isSaturday?._d).format("dddd") === "Saturday" &&
                      (isSaturday &&
                        weekendShiftUser?.notApplicable === false &&
                        weekendShiftUser?.saturdayEnabled &&
                        weekendShiftUser?.saturdayType === "halfday") ||
                      // moment(isSunday?._d).format("dddd") === "Sunday" &&
                      (isSunday &&
                        weekendShiftUser?.notApplicable === false &&
                        weekendShiftUser?.sundayEnabled &&
                        weekendShiftUser?.sundayType === "halfday")
                        ? false
                        : halfDay
                    }
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Spin spinning={showLeaveValidationLoader}>
              <Form.Item label="No. of Days" name="number_of_days">
                <InputNumber min={0.5} onChange={updateEndDate} disabled />
              </Form.Item>
            </Spin>
          </Col>
          <Col xs={24} sm={24} md={12}>
            {showHalfDayCheckbox && (
              <Checkbox
                style={checkBoxStyle}
                checked={halfDay}
                onChange={(e) => {
                  updateHalfDay(!halfDay);
                  setHalfDay((prevCheck) => !prevCheck);
                }}
                disabled={
                  // moment(isSaturday?._d).format("dddd") === "Saturday" &&
                  (isSaturday &&
                    weekendShiftUser?.notApplicable === false &&
                    weekendShiftUser?.saturdayEnabled &&
                    weekendShiftUser?.saturdayType === "halfday") ||
                  // moment(isSunday?._d).format("dddd") === "Sunday" &&
                  (isSunday &&
                    weekendShiftUser?.notApplicable === false &&
                    weekendShiftUser?.sundayEnabled &&
                    weekendShiftUser?.sundayType === "halfday")
                    ? true
                    : false
                }
              >
                Half day
              </Checkbox>
            )}
          </Col>

          {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Department"
              name="department"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Department is required",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Department"
                name="department"
                options={concat(
                  {
                    department_id: "",
                    department_name: "Select Department",
                  },
                  filterDepartment
                )}
                fieldNames={{
                  label: "department_name",
                  value: "department_id",
                }}
                disabled={isViewOnly || editLeaveDisable}
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col> */}
        </Row>

        {!isViewOnly && (
          <div>
            {isCancelRequest && (
              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const leave_type = getFieldValue("leave_type");
                  return (
                    leave_type !== true && (
                      <Form.Item
                        label="Detailed Reason"
                        name="description"
                        rules={[
                          {
                            required: true,
                            pattern: NON_EMPTY_REGEX,
                            message: "Leave reason is required",
                          },
                        ]}
                      >
                        <TextArea
                          placeholder="Type something.."
                          maxLength={500}
                          disabled={isViewOnly}
                          autoSize={{ minRows: 2, maxRows: 6 }}
                        />
                      </Form.Item>
                    )
                  );
                }}
              </Form.Item>
            )}
            {!isCancelRequest && (
              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const leave_type = getFieldValue("leave_type");
                  return (
                    leave_type !== true && (
                      <Form.Item
                        label="Detailed Reason"
                        name="description"
                        rules={[
                          {
                            required: form.getFieldValue("leave_type"),
                            pattern: NON_EMPTY_REGEX,
                            message: "Reason is required",
                          },
                        ]}
                      >
                        <TextArea
                          laceholder="Type something.."
                          maxLength={500}
                          disabled={isViewOnly}
                          autoSize={{ minRows: 2, maxRows: 6 }}
                        />
                      </Form.Item>
                    )
                  );
                }}
              </Form.Item>
            )}
          </div>
        )}
        {!isViewOnly && (
          <StyledFooterDiv className="align-right">
            {!isCancelRequest && (
              <StyledButton
                type="primary"
                onClick={() => {
                  resetForm();
                  resetHalfDay();
                }}
                disabled={showLeaveValidationLoader}
              >
                Reset All
              </StyledButton>
            )}
            <StyledButton
              loading={showLoader}
              type="primary"
              htmlType="submit"
              disabled={showLeaveValidationLoader}
            >
              {showLoader ? "Submitting" : "Submit"}
            </StyledButton>
          </StyledFooterDiv>
        )}
      </Form>
    </StyledModal>
  );
}

const mapStateToProps = (state) => ({
  leaveCategoryList: getLeaveCategoryList(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  AllDepartmentList: getAllDepartmentList(state),
  userRoleId: getUserRoleId(state),
  roleList: getRoleList(state),
  userList: getUserList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  leaveList: getLeaveList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLeaveListData: setLeaveList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(LeaveForm);
